const getters = {
  getInSuccessHeadMsg: (state) => (type) => {
    const t = state.referrer[type];
    return t ? state.inSuccessText[t].headMsg : '';
  }
};
export default getters;
